document.querySelectorAll('[data-product-carousel]').forEach(function (carousel) {
  var track = carousel.querySelector('[data-carousel-track]');
  var previous = carousel.querySelector('[data-carousel-prev]');
  var next = carousel.querySelector('[data-carousel-next]');
  if (!track || !previous || !next) return;

  function updateControls() {
    var maxScroll = track.scrollWidth - track.clientWidth;
    previous.disabled = track.scrollLeft <= 1;
    next.disabled = track.scrollLeft >= maxScroll - 1;
  }

  previous.addEventListener('click', function () {
    track.scrollBy({ left: -(track.clientWidth * 0.8), behavior: 'smooth' });
  });
  next.addEventListener('click', function () {
    track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
  });
  track.addEventListener('scroll', updateControls, { passive: true });
  window.addEventListener('resize', updateControls);
  updateControls();
});
